<template>
    <span class="translate" :class="[{ 'disabled': disabled }]" @click.prevent="() => {
        if (!disabled)
            dialog['show'] = !dialog['show']
    }">{{ _value
        || (value ? 'درحال دریافت...' : '') }}</span>
    <input :class="[{ 'has': value && base.Util().validate(String(value)) }]" v-model="value" :readonly="true"
        :disabled="true" hidden>
    <i v-if="value && base.Util().validate(String(value)) && !disabled" class="vscenter toggle fe fe-16 fe-x" @click="() => {
        value = ''
        _value = ''
    }"></i>
    <Dialog v-if="!disabled" :data="dialog[dialog.active]" :show="dialog['show']"
        @onclose="() => dialog['show'] = false" @onresult="(obj) => {
            value = obj
            dialog['show'] = false
        }">
    </Dialog>
</template>

<script>
/* eslint-disable */
import { defineAsyncComponent } from 'vue'

export default {
    name: 'UniqueIdentifier',
    props: ['meta', 'vm', 'disabled', 'internal'],
    inject: ['base'],
    components: { Dialog: defineAsyncComponent(() => import('../../Dialog.vue')), },
    created() {
        this.resolve()
        this.dialog = {
            finder: {
                type: 'finder',
                title: 'جست و جو شناسه یکتا',
                vm: this.vm,
                halfwidth: this.internal,
                relative: this.internal,
                thin: !this.internal,
                ultra: !this.internal,
                internal: true,
                closeable: true
            },
            active: 'finder',
            show: false
        }
    },
    data() {
        return {
            key: this.base.Entities().parse(this.meta.extras)['key'] || 'display_name,company_name',
            value: this.vm || '',
            hint: '',
            error: false,
            _value: '',
            dialog: {}
        }
    },
    watch: {
        vm(newVM, oldVM) {
            if (this.value !== this.vm) {
                this.value = this.vm
                if (!this.value)
                    this._value = ''
                this.hint = ''
            }
        },
        value() {
            this.resolve()

            this.$emit('onchange', {
                value: String(this.value),
                hint: this.hint,
                error: this.error
            })
        }
    },
    methods: {
        resolve() {
            if (this.value)
                this.base.API().post(`Identities/Account/GetProperty`, {
                    data: {
                        key: this.key,
                        value: this.value
                    }
                }, (response) => {
                    if (this.base.Util().success(response) && response.data.data)
                        this._value = response.data.data
                    else
                        this._value = `${this.meta.name} یافت نشد!`
                }, (error) => {
                    this._value = 'خطا در دریافت اطلاعات!'
                    setTimeout(() => this.resolve(), 3000)
                })
        }
    }
}
</script>